import _get from 'lodash/get';

export default {
  i18n: _get(window, 'AppConfig.i18n', {}),
};
